var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNav2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 16V14C9.87827 14 7.84344 14.8429 6.34315 16.3431C4.84285 17.8434 4 19.8783 4 22H6C6 20.4087 6.63214 18.8826 7.75736 17.7574C8.88258 16.6321 10.4087 16 12 16ZM6 7C6 10.315 8.685 13 12 13C15.315 13 18 10.315 18 7C18 3.685 15.315 1 12 1C8.685 1 6 3.685 6 7ZM16 7C16 9.21 14.21 11 12 11C9.79 11 8 9.21 8 7C8 4.79 9.79 3 12 3C14.21 3 16 4.79 16 7ZM22.95 21.536L21.446 20.032C21.9405 19.1933 22.1121 18.2031 21.9288 17.247C21.7454 16.2908 21.2196 15.4343 20.4499 14.8381C19.6802 14.2419 18.7195 13.9469 17.7479 14.0083C16.7762 14.0698 15.8604 14.4835 15.1719 15.1719C14.4835 15.8604 14.0698 16.7762 14.0083 17.7479C13.9469 18.7195 14.2419 19.6802 14.8381 20.4499C15.4343 21.2196 16.2908 21.7454 17.247 21.9288C18.2031 22.1121 19.1933 21.9405 20.032 21.446L21.536 22.95L22.95 21.536ZM19.4142 19.4142C19.0391 19.7893 18.5304 20 18 20C17.4696 20 16.9609 19.7893 16.5858 19.4142C16.2107 19.0391 16 18.5304 16 18C16 17.4696 16.2107 16.9609 16.5858 16.5858C16.9609 16.2107 17.4696 16 18 16C18.5304 16 19.0391 16.2107 19.4142 16.5858C19.7893 16.9609 20 17.4696 20 18C20 18.5304 19.7893 19.0391 19.4142 19.4142Z",
    fill: "#EBEDEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNav2);
export default __webpack_public_path__ + "static/media/nav-2.acb0bb4bf3cbdfed6677eb4fa71083f5.svg";
export { ForwardRef as ReactComponent };